import { FInter, FlexBox, useToasts, useIsMobile, useBreakpoint, MagicBox, MagicBoxRow } from '@brg/ui';
import { useAuth } from '../../../core/hooks/auth/useAuth';
import { useProfile } from '../../../core/hooks/auth/useProfile';
import { useHistory } from 'react-router-dom';
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { API, Competition, CompetitionAPI, Endpoints, Nullable, Project, UserSignAPI, GetProjectsByFilterProps, ProjectAPI, Tag } from '@brg/api';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import { LayoutConst, bTag, useModal } from '../../../core';
import { ActionsTitle, ActionsWrapper, ActionsColumnBlock, ProjectsCount, MainTitle, ActionBottomButtons, ModalContainer, TagsTitle, SendButton, ExamTitle, CreateButton, ExamFooterButtons, DeselectButton, SubmitButton, SelectedProjectName, SelectedProjectWrapper, SelectedProjectDesc, TagsString, SubtitleTagsString, HeaderSendButton } from './styles';
import { Outer } from 'shared/pages/explore/styles';
import { ProjectsSearchBar } from 'shared/components/projectsSearchBar/projectsSearchBar';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { AppTester } from 'supporting';
import { ProjectsGridNew } from 'shared/components/grids';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import { ProjectDelegate } from 'project-delegate';
import { RingPositions } from 'shared/constants/ringPositionType';
import { BTag } from 'core/components';
import { SendProjectModalWrapper } from './employStyles';
import { CompleteSend } from './SendProjectForEmploy';
import { useGetLimitSendCompetition } from 'shared/hooks/useGetLimitSendCompetition';
import { getMaxLimitAttemptsPerUser } from 'shared/helpers/getMaxLimitAttemptsPerUser';
import { CompetitionDisableBtnStatus } from 'shared/pages/opencallsPage/GetCompetitionItem/ActionsButtons';
import { CurrentCompetitionSelector } from 'shared/reducers/CurrentCompetitionSlice';
import { BTagsGridNew } from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { BackButton } from 'shared/pages/notfound/styles';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { BrgButton, BrgButtonThin } from 'shared/components/buttons';
import CompetitionSelectPanel from 'shared/navbars/CompetitionPanel/CompetitionSelectPanel';
import useCompetitionActions from 'shared/hooks/useCompetitionActions';
import SendProjectCheckbox from './SendProjectsCheckbox';
import { NoProjectPrompt } from './NoProjectPrompt';
import { useProjectsList } from 'shared/hooks/api/useProjectsByFilter';
import { isPromptModule } from 'shared/pages/exploreHseContextsNew/const/promptFormsId';
import { SendProjectsEntity } from './SendProjectsEntity';
import { SlideNavigation } from 'shared/components/slideNavigation';
import { DropdownTabs } from 'shared/pages/exploreHseContextsOldDeprecated/components/DropdownTabs';
import { SendProjectsTabs } from './components/SendProjectsTabs';
import { SendProjectsContent } from './components/SendProjectsContent';
import { useUserPaidCard } from './hooks/useUserPaidCard';
import {
  PAID_WITH_FORM_LEGAL_ENTITIES_FORM_ID,
  TEAM_FORM_CONTINUE_COMPETITION_QUERY,
  TEAM_FORM_DEFER_APPLY_PROJECT_QUERY,
} from '_competition/const';

export enum SEND_PROJECT_TABS {
  projects = 'projects',
  approved = 'approved'
}


const hseDomains: Record<string, string> = { en: process.env.REACT_APP_URL_HSEDESIGN_COM || '', ru: process.env.REACT_APP_URL_HSEDESIGN_RU || '' }


export const BackLink = styled(FInter.SectionTitleDiv)`
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.71;
  }
`;


export const NeedLogin = (props: { competition?: Competition }) => {
  const auth = useAuth();
  const history = useHistory();
  const theme = useTheme();
  return (
    <Outer>
      <FlexBox style={{ flexFlow: "column" }} offsetTop={24} offsetRight={20} offsetLeft={20}>
        <div style={{ marginBottom: '40px' }}>
          <BackLink onClick={() => history.push('/competition/' + props.competition?.competitionId)}>
            <span>←</span> {props.competition?.name}
          </BackLink>
        </div>
        <ActionsColumnBlock>
          <FInter.TextDiv color={theme.competition.frameMainText}>
            Для того, чтобы отправить работу на участие в конкурсе <b>{props.competition?.name}</b> необходимо войти
          </FInter.TextDiv>
          <FlexBox offsetTop={20}>
            <SendProjectButton onClick={() => auth.login()}>Войти</SendProjectButton>
          </FlexBox>
        </ActionsColumnBlock>
      </FlexBox>
    </Outer>);
};


interface IProps {
  id: string;
  onApplyClick?: () => void;
  selectedProjectId?: string;
  singleProjectSelection?: boolean;
  legalContestProjectThenForm?: boolean;
  resumeLegalContestDeferredApply?: boolean;
}

export const SendProjectModal: FC<IProps> = ({
  id: competitionId,
  onApplyClick: onPayApplyClick,
  selectedProjectId,
  singleProjectSelection,
  legalContestProjectThenForm = false,
  resumeLegalContestDeferredApply = false,
}) => {
  const profile = useProfile();
  const theme = useTheme();
  const history = useHistory();
  const toasts = useToasts();
  const { userAttempts } = useSelector(CurrentCompetitionSelector);
  const [competition, setCompetition] = useState<Competition>();
  const [time, setT] = useState(new Date().getTime());
  const isMobile = useIsMobile();
  const { i18n, t } = useTranslation();
  const modal = useModal();
  const [tab, setTab] = useState<SEND_PROJECT_TABS>(SEND_PROJECT_TABS.projects)
  const [sorting, setSorting] = useState(1);
  // const [projects, setProjects] = useState<Project[]>([]);
  const [isSendWithoutProject, setIsSendWithoutProject] = useState(false);
  const [showWithoutProjectsModal, setShowWithoutProjectsModal] = useState(false);
  const hasCalledOnApplyClick = useRef(false); // Флаг для предотвращения повторных вызовов
  const hasPreselectedProjectRef = useRef(false);
  const resumeLegalContestApplyOnceRef = useRef(false);

  const [{ allowedInfo, allowedStatus, isMaxAttemptsLimitLoading }] = useGetLimitSendCompetition(competition ?? {} as Competition<'Local'>);
  const {
    handleCreateProject,
    tagString,
    isExam,
    selectedProjects,
    setSelectedProjects,
    isPaidParticipationContest,
    isPromptCompetition,
    shouldDisplayNoProjectsCheckbox,
    handleSubmitFor,
    getLegalsModal,
    canApplyWithoutProject,
    needToFillForm,
    onApplyClick,
    setShouldSendPrivate,
    shouldSendPrivate,
  } = useCompetitionActions(competition);

  const isSingleProjectSelection = singleProjectSelection || (isExam && !isPromptCompetition);

  useEffect(() => {
    if (competitionId) {
      CompetitionAPI.Get({ idCompetition: competitionId })
        .then(v => v.json())
        .then((v) => API.toLang<Competition>(v, i18n.language))
        .then((v) => {
          setCompetition(v);
        });
    }
  }, [i18n.language, competitionId]);

  const competitionTags: string[] = useMemo(
    () => {
      if (competition) {
        return [
          ...competition?.tags,
          ...competition?.regularTags,
          ...competition?.requredTags
        ]
          ?.map((tag) => tag?.tagId) || []
      }

      return [];
    }, [competition])

  const canAcceptPrivatePublished = useMemo(() => {
    return competition?.acceptPrivatePublished;
  }, [competition]);

  const filterOpt = useMemo(() => {
    if (profile && profile.accountId && competitionId && competition) {
      return {
        authorIds: [profile.accountId],
        projectFilter: sorting,
        isContextIgnored: true,
        projectStatus: canAcceptPrivatePublished ? [1, 7, 10] : [1, 7],
        ...(isPromptCompetition ? {} : { exceptCompetitionIds: [competitionId] }),
        onlyAuthors: false,
        ...(!!competitionTags?.length && { tagIds: competitionTags }),
        onlyBooks: ''
      }
    }
  },
    [competitionId, profile, sorting, isPromptCompetition, competitionTags, competition]
  );

  const [projectsPageModel, isProjectsLoading] = useProjectsList(filterOpt, i18n.language, time, !filterOpt)


  const projects = useMemo(() => {
    if (isProjectsLoading) return []
    return projectsPageModel?.data || []
  }, [projectsPageModel, isProjectsLoading])

  const alreadyProjects = useMemo(() => {
    return projects.reduce((acc, p) => {
      if (p?.competitionApproves && (!!p?.competitionApproves?.length || !!p?.pendingCompetitionIds?.length) && competitionId) {
        //@ts-ignore
        if (!!p.competitionApproves?.find?.(({ competitionId }) => competitionId === competition?.competitionId) || p?.pendingCompetitionIds?.includes(competitionId)) // условие необходимо если проекты смогут быть в разных конкурсах
          return [...acc, p?.projectId];
      }
      return acc;
    }, [])
  }, [projects])

  const haveProjects = projects?.length > 0

  //@ts-ignore

  useEffect(() => {
    if (profile && profile.accountId) {
      UserSignAPI.CheckSignsDocuments({
        service: ['competitions'],
        userId: profile.accountId
      })
        .then(d => {
          if (d.status === 200) return d.json(); // список доков
          //if (d.status === 204) setLegalsSigned(false); // у юзера нет неподписанных доков
        })
        .then((d: any) => {
          // //@ts-ignore
          // if (d && competition && competition?.nominations && competition?.nominations[0]?.documentsIds){
          //   //@ts-ignore
          //   const needSign = d.some(x => competition?.nominations[0]?.documentsIds.includes(x));
          //   //setLegalsSigned(needSign);
          //   // d.map((i) => {
          //   //   //@ts-ignore
          //   //   setLegalsSigned(competition?.nominations[0]?.documentsIds.includes(i.documentId))
          //   // })
          // }
        })
    }
  }, [profile, competition]);

  const { userPaidCard } = useUserPaidCard({ competitionId, isPaidApplication: isPaidParticipationContest });

  useEffect(() => {
    if (!resumeLegalContestDeferredApply || !selectedProjectId) {
      return;
    }
    if (!profile) {
      return;
    }
    if (!competition || competition.competitionId !== competitionId) {
      return;
    }
    if (resumeLegalContestApplyOnceRef.current) {
      return;
    }
    resumeLegalContestApplyOnceRef.current = true;

    void onApplyClick({
      forceSelectedProjectId: selectedProjectId,
      makePrivate: shouldSendPrivate,
    });
  }, [
    resumeLegalContestDeferredApply,
    selectedProjectId,
    profile,
    competition,
    competitionId,
    shouldSendPrivate,
    onApplyClick,
  ]);

  const onSendWithoutProjects = useCallback(() => {
    setIsSendWithoutProject(!isSendWithoutProject);
  }, [isSendWithoutProject])

  const maxProjects = useMemo(() => {
    if (isSingleProjectSelection) {
      return 1;
    }
    if (isPaidParticipationContest && !userPaidCard) {
      return 1;
    }
    return (allowedStatus?.allowedMax || 0) - (allowedStatus?.allowedCurrent || 0);
  }, [isSingleProjectSelection, isPaidParticipationContest, userPaidCard, allowedStatus]);

  // Автоматически выбираем проект при возврате от экваиринга
  useEffect(() => {
    if (selectedProjectId && projects.length > 0 && !hasCalledOnApplyClick.current && !hasPreselectedProjectRef.current) {
      const projectExists = projects.some(project => project.projectId === selectedProjectId);

      if (projectExists && !selectedProjects.includes(selectedProjectId)) {
        hasPreselectedProjectRef.current = true;
        setSelectedProjects([selectedProjectId]);
        // Автоматически вызываем onApplyClick если это возврат от экваиринга
        if (onPayApplyClick && !needToFillForm) {
          hasCalledOnApplyClick.current = true; // Устанавливаем флаг
          setTimeout(() => {
            // Вызываем onApplyClick с актуальным selectedProjectId напрямую
            onApplyClick({
              forceSelectedProjectId: selectedProjectId,
              makePrivate: shouldSendPrivate,
            });
          }, 100);
        }
      }
    }
  }, [selectedProjectId, projects, selectedProjects, onPayApplyClick, needToFillForm, onApplyClick, competitionId, shouldSendPrivate, setSelectedProjects])

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
    //setT(Date.now());
  }, []);

  const handleSendWihoutProject = () => {
    const confirm = window.confirm(`Подать заявку на участие без проекта?`)

    if (confirm) {
      try {
        API.request()
          .endpoint(Endpoints.competitions)
          .url('/api/Competition/RequestParticipantToCompetition')
          .post()
          .addQuery('competitionId', competition?.competitionId || '')
          .send()
          .then((r) => {
            if (r?.status === 200) {
              setShowWithoutProjectsModal(true);
            }
          })
      }
      catch (err) {
        console.error('Что-то пошло не так');
      }
    }
  }

  const onMobileSortingClick = useCallback(() => {
    setSorting(sorting === 1 ? 2 : 1);
  }, [sorting, setSorting]);
  const selectedProjectName = useMemo(() => {
    if (selectedProjects.length === 0) return '';
    const selectedProject = projects.find(p => p.projectId === selectedProjects[0]);
    return selectedProject?.title || '';
  }, [selectedProjects, projects]);

  const handleDeselectProject = useCallback(() => {
    setSelectedProjects([]);
  }, []);

  const isAlreadyProject = useCallback((data: string | undefined) => {
    if (alreadyProjects && alreadyProjects.length > 0) {
      return data ? alreadyProjects.includes(data) : false;
    }
  }, [alreadyProjects])

  const noProjectsRequestCheckbox = useMemo(() => (
    <SendProjectCheckbox text={t('teams.modal.without_projects')} checked={isSendWithoutProject} onClick={onSendWithoutProjects} />
  ), [onSendWithoutProjects, t, isSendWithoutProject])

  const disableSend = useMemo(
    () => (canApplyWithoutProject ? (!isSendWithoutProject && selectedProjects?.length === 0) : selectedProjects?.length === 0)
    , [isSendWithoutProject, selectedProjects, canApplyWithoutProject])

  const remainingAttempts = useMemo(() => {
    const maxLimit = getMaxLimitAttemptsPerUser(competition);
    if (maxLimit == null) {
      return undefined;
    }
    const current = allowedStatus?.currentAttemptsPerUser ?? 0;
    return Math.max(maxLimit - current, 0);
  }, [competition, allowedStatus?.currentAttemptsPerUser]);

  const isAttemptsLimitReached = remainingAttempts === 0
    || !!allowedInfo?.includes(CompetitionDisableBtnStatus.max_attempts_per_user)
    || (!!userAttempts
      && userAttempts.competitionId === competitionId
      && userAttempts.max >= 1
      && userAttempts.current >= userAttempts.max);

  const allProjectsSelected = useMemo(() => {
    if (!projects.length || !selectedProjects.length) {
      return false;
    }
    if (remainingAttempts != null) {
      return selectedProjects.length >= Math.min(projects.length, remainingAttempts);
    }
    return projects.length === selectedProjects.length;
  }, [projects, selectedProjects, remainingAttempts]);

  const selectProject = useCallback((projectId: string) => {
    if (isPromptCompetition && isAlreadyProject(projectId)) return;

    setSelectedProjects((prev: string[]) => {
      if (isSingleProjectSelection) {
        return prev.includes(projectId) ? prev.filter(a => a !== projectId) : [projectId];
      }
      if (prev.includes(projectId)) return prev.filter(a => a !== projectId);
      if (remainingAttempts != null && prev.length >= remainingAttempts) {
        toasts.error(t('competition.max_attempts_per_user_reached'));
        return prev;
      }
      return [...prev, projectId];
    });
  }, [isSingleProjectSelection, setSelectedProjects, isPromptCompetition, isAlreadyProject, remainingAttempts, toasts, t]);

  const handleSelectAll = useCallback(() => {
    if (allProjectsSelected) {
      setSelectedProjects([]);
      return;
    }

    if (remainingAttempts != null && projects.length > remainingAttempts) {
      toasts.error(t('competition.max_attempts_per_user_reached'));
      setSelectedProjects(projects.slice(0, remainingAttempts).map((p) => p.projectId));
      return;
    }

    setSelectedProjects(projects.map((p) => p.projectId));
  }, [allProjectsSelected, projects, setSelectedProjects, remainingAttempts, toasts, t]);

  const shouldDisplayTagsString = !!tagString?.length && haveProjects;

  const shouldVisibleNoProjectPromt = useMemo(() => {
    return !haveProjects && !!competition && !isProjectsLoading;
  }, [isProjectsLoading, haveProjects, competition]);

  const isNoProjectsReadyState = shouldVisibleNoProjectPromt;

  const sendProjectsMainTitleText = useMemo(() => {
    if (legalContestProjectThenForm) {
      return t('competition.select_project');
    }
    if (isPaidParticipationContest) {
      return t('competition.pay_title');
    }
    return t('competition.select_project');
  }, [legalContestProjectThenForm, isPaidParticipationContest, t]);

  const handleSubmit = () => {
    if (isSingleProjectSelection && selectedProjects.length > 1) {
      setSelectedProjects(selectedProjects.slice(0, 1));
      return;
    }

    if (legalContestProjectThenForm) {
      const pid = selectedProjects[0];
      if (!pid) {
        toasts.error(t('competition.select_project'));
        return;
      }
      const qs = new URLSearchParams({
        [TEAM_FORM_CONTINUE_COMPETITION_QUERY]: competitionId,
        [TEAM_FORM_DEFER_APPLY_PROJECT_QUERY]: pid,
      }).toString();
      modal.hide();
      history.push(`/teams/form/${PAID_WITH_FORM_LEGAL_ENTITIES_FORM_ID}?${qs}`);
      return;
    }

    if (isSendWithoutProject && selectedProjects?.length === 0) {
      handleSendWihoutProject();
    } else if (isPaidParticipationContest && !userPaidCard) {
      handleSubmitFor({
        projectName: selectedProjectName,
      });
    } else {
      getLegalsModal(needToFillForm, onApplyClick);
    }
  };

  const checkboxComponent = useMemo(() => {
    if (isNoProjectsReadyState) {
      return shouldDisplayNoProjectsCheckbox ? noProjectsRequestCheckbox : null
    }
    if (shouldDisplayNoProjectsCheckbox) {
      return noProjectsRequestCheckbox
    }
    return (
      <>
        {!isSingleProjectSelection && (
          <MagicBoxRow
            onClick={handleSelectAll}
            checked={allProjectsSelected}
            label={t('competition.select_all')}
          />
        )}
        {/* <SendProjectCheckbox
          onClick={handleSelectAll}
          checked={allProjectsSelected}
          text={t('competition.select_all')}
        /> */}
        {competition?.acceptPrivatePublished && (
          <MagicBoxRow
            onClick={() => setShouldSendPrivate(!shouldSendPrivate)}
            checked={shouldSendPrivate}
            label={t('competition.send_private_published')}
          />
        )}
      </>
    )
  }, [isNoProjectsReadyState, shouldDisplayNoProjectsCheckbox, noProjectsRequestCheckbox, isSingleProjectSelection, handleSelectAll, allProjectsSelected, t, competition?.acceptPrivatePublished, setShouldSendPrivate, shouldSendPrivate])

  const tabsComponent = useMemo(() => {
    if (isPromptCompetition) {
      return <SendProjectsTabs tab={tab} onTabChange={setTab} />
    }
    return undefined
  }, [tab, isPromptCompetition]);

  if (!profile) {
    return <NeedLogin competition={competition} />;
  }

  return (
    <ModalContainer style={{ overflow: 'auto', height: '100%' }} justify="flex-start" offsetTop={88} offsetTopMobile={1}>
      <SendProjectModalWrapper directionMobile='column' justify={isMobile ? 'flex-start' : 'center'} align={isMobile ? "center" : 'flex-start'} style={{ position: 'relative' }}>
        <SendProjectsEntity
          isCompetitionModal
          noProjectCheckbox={checkboxComponent}
          titleText={sendProjectsMainTitleText}
          hideMainTitle={isNoProjectsReadyState && !isPaidParticipationContest}
          hideSendButton={isNoProjectsReadyState || isAttemptsLimitReached || isMaxAttemptsLimitLoading}
          subtitleText={shouldDisplayTagsString ? t('competition_edit.create_project_with_tags') + tagString : undefined}
          tabs={tabsComponent}
          noProjectVisible
          hideCount
          hideFilter
          count={0}
          isDisabledSendButton={isAttemptsLimitReached || isMaxAttemptsLimitLoading}
          onMobileSortingClick={onMobileSortingClick}
          onSortingChange={onSortingChange}
          sorting={sorting}
          onSend={() => {
            if (isAttemptsLimitReached) {
              toasts.error(t('competition.max_attempts_per_user_reached'));
              return;
            }
            handleCreateProject('_SELF', { legalContestFormAfterPublish: legalContestProjectThenForm })
          }}
          // isClosed={!(!isSendingCompleted)}
          hide={false}
          sendText={t('competition.create_new_project')}
          showMobileClose
        >
          {filterOpt && (
            <SendProjectsContent
              competition={competition}
              projects={projects}
              selectedProjects={selectedProjects}
              activeTab={tab}
              noProjectsVisible={shouldVisibleNoProjectPromt}
              loading={isProjectsLoading}
              onSelect={selectProject}
              isAlreadyProject={isAlreadyProject}
              legalContestFormAfterPublish={legalContestProjectThenForm}
              isAttemptsLimitReached={isAttemptsLimitReached}
            />
          )}
        </SendProjectsEntity>
        {!showWithoutProjectsModal && (
          <CompetitionSelectPanel
            isEmptyRequest={isSendWithoutProject}
            selectedCount={selectedProjects?.length}
            selectedProjectName={selectedProjectName}
            maxProjects={maxProjects}
            onDeselect={handleDeselectProject}
            onPublish={handleSubmit}
            disabled={disableSend}
          />
        )}
        {showWithoutProjectsModal && <CompleteSend isCompetition title={competition?.name || ''} contextName={''} withoutProjects={true} />}
      </SendProjectModalWrapper>
    </ModalContainer>
  );
};
import { FInter, FlexBox, useToasts, useIsMobile, useBreakpoint, MagicBox, MagicBoxRow } from '@brg/ui';
import { useAuth } from '../../../core/hooks/auth/useAuth';
import { useProfile } from '../../../core/hooks/auth/useProfile';
import { useHistory } from 'react-router-dom';
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { API, Competition, CompetitionAPI, Endpoints, Nullable, Project, UserSignAPI, GetProjectsByFilterProps, ProjectAPI, Tag } from '@brg/api';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import { LayoutConst, bTag, useModal } from '../../../core';
import { ActionsTitle, ActionsWrapper, ActionsColumnBlock, ProjectsCount, MainTitle, ActionBottomButtons, ModalContainer, TagsTitle, SendButton, ExamTitle, CreateButton, ExamFooterButtons, DeselectButton, SubmitButton, SelectedProjectName, SelectedProjectWrapper, SelectedProjectDesc, TagsString, SubtitleTagsString, HeaderSendButton } from './styles';
import { Outer } from 'shared/pages/explore/styles';
import { ProjectsSearchBar } from 'shared/components/projectsSearchBar/projectsSearchBar';
import { SortingTypeIndex } from 'shared/constants/sortingType';
import { SendProjectButton } from '_competition/components/SendProjectButton';
import { AppTester } from 'supporting';
import { ProjectsGridNew } from 'shared/components/grids';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import { ProjectDelegate } from 'project-delegate';
import { RingPositions } from 'shared/constants/ringPositionType';
import { BTag } from 'core/components';
import { SendProjectModalWrapper } from './employStyles';
import { CompleteSend } from './SendProjectForEmploy';
import { useGetLimitSendCompetition } from 'shared/hooks/useGetLimitSendCompetition';
import { getMaxLimitAttemptsPerUser } from 'shared/helpers/getMaxLimitAttemptsPerUser';
import { CompetitionDisableBtnStatus } from 'shared/pages/opencallsPage/GetCompetitionItem/ActionsButtons';
import { CurrentCompetitionSelector } from 'shared/reducers/CurrentCompetitionSlice';
import { BTagsGridNew } from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { BackButton } from 'shared/pages/notfound/styles';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { BrgButton, BrgButtonThin } from 'shared/components/buttons';
import CompetitionSelectPanel from 'shared/navbars/CompetitionPanel/CompetitionSelectPanel';
import useCompetitionActions from 'shared/hooks/useCompetitionActions';
import SendProjectCheckbox from './SendProjectsCheckbox';
import { NoProjectPrompt } from './NoProjectPrompt';
import { useProjectsList } from 'shared/hooks/api/useProjectsByFilter';
import { isPromptModule } from 'shared/pages/exploreHseContextsNew/const/promptFormsId';
import { SendProjectsEntity } from './SendProjectsEntity';
import { SlideNavigation } from 'shared/components/slideNavigation';
import { DropdownTabs } from 'shared/pages/exploreHseContextsOldDeprecated/components/DropdownTabs';
import { SendProjectsTabs } from './components/SendProjectsTabs';
import { SendProjectsContent } from './components/SendProjectsContent';
import { useUserPaidCard } from './hooks/useUserPaidCard';
import {
  PAID_WITH_FORM_LEGAL_ENTITIES_FORM_ID,
  TEAM_FORM_CONTINUE_COMPETITION_QUERY,
  TEAM_FORM_DEFER_APPLY_PROJECT_QUERY,
} from '_competition/const';

export enum SEND_PROJECT_TABS {
  projects = 'projects',
  approved = 'approved'
}


const hseDomains: Record<string, string> = { en: process.env.REACT_APP_URL_HSEDESIGN_COM || '', ru: process.env.REACT_APP_URL_HSEDESIGN_RU || '' }


export const BackLink = styled(FInter.SectionTitleDiv)`
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.71;
  }
`;


export const NeedLogin = (props: { competition?: Competition }) => {
  const auth = useAuth();
  const history = useHistory();
  const theme = useTheme();
  return (
    <Outer>
      <FlexBox style={{ flexFlow: "column" }} offsetTop={24} offsetRight={20} offsetLeft={20}>
        <div style={{ marginBottom: '40px' }}>
          <BackLink onClick={() => history.push('/competition/' + props.competition?.competitionId)}>
            <span>←</span> {props.competition?.name}
          </BackLink>
        </div>
        <ActionsColumnBlock>
          <FInter.TextDiv color={theme.competition.frameMainText}>
            Для того, чтобы отправить работу на участие в конкурсе <b>{props.competition?.name}</b> необходимо войти
          </FInter.TextDiv>
          <FlexBox offsetTop={20}>
            <SendProjectButton onClick={() => auth.login()}>Войти</SendProjectButton>
          </FlexBox>
        </ActionsColumnBlock>
      </FlexBox>
    </Outer>);
};


interface IProps {
  id: string;
  onApplyClick?: () => void;
  selectedProjectId?: string;
  singleProjectSelection?: boolean;
  legalContestProjectThenForm?: boolean;
  resumeLegalContestDeferredApply?: boolean;
}

export const SendProjectModal: FC<IProps> = ({
  id: competitionId,
  onApplyClick: onPayApplyClick,
  selectedProjectId,
  singleProjectSelection,
  legalContestProjectThenForm = false,
  resumeLegalContestDeferredApply = false,
}) => {
  const profile = useProfile();
  const theme = useTheme();
  const history = useHistory();
  const toasts = useToasts();
  const { userAttempts } = useSelector(CurrentCompetitionSelector);
  const [competition, setCompetition] = useState<Competition>();
  const [time, setT] = useState(new Date().getTime());
  const isMobile = useIsMobile();
  const { i18n, t } = useTranslation();
  const modal = useModal();
  const [tab, setTab] = useState<SEND_PROJECT_TABS>(SEND_PROJECT_TABS.projects)
  const [sorting, setSorting] = useState(1);
  // const [projects, setProjects] = useState<Project[]>([]);
  const [isSendWithoutProject, setIsSendWithoutProject] = useState(false);
  const [showWithoutProjectsModal, setShowWithoutProjectsModal] = useState(false);
  const hasCalledOnApplyClick = useRef(false); // Флаг для предотвращения повторных вызовов
  const hasPreselectedProjectRef = useRef(false);
  const resumeLegalContestApplyOnceRef = useRef(false);

  const [{ allowedInfo, allowedStatus, isMaxAttemptsLimitLoading }] = useGetLimitSendCompetition(competition ?? {} as Competition<'Local'>);
  const {
    handleCreateProject,
    tagString,
    isExam,
    selectedProjects,
    setSelectedProjects,
    isPaidParticipationContest,
    isPromptCompetition,
    shouldDisplayNoProjectsCheckbox,
    handleSubmitFor,
    getLegalsModal,
    canApplyWithoutProject,
    needToFillForm,
    onApplyClick,
    setShouldSendPrivate,
    shouldSendPrivate,
  } = useCompetitionActions(competition);

  const isSingleProjectSelection = singleProjectSelection || (isExam && !isPromptCompetition);

  useEffect(() => {
    if (competitionId) {
      CompetitionAPI.Get({ idCompetition: competitionId })
        .then(v => v.json())
        .then((v) => API.toLang<Competition>(v, i18n.language))
        .then((v) => {
          setCompetition(v);
        });
    }
  }, [i18n.language, competitionId]);

  const competitionTags: string[] = useMemo(
    () => {
      if (competition) {
        return [
          ...competition?.tags,
          ...competition?.regularTags,
          ...competition?.requredTags
        ]
          ?.map((tag) => tag?.tagId) || []
      }

      return [];
    }, [competition])

  const canAcceptPrivatePublished = useMemo(() => {
    return competition?.acceptPrivatePublished;
  }, [competition]);

  const filterOpt = useMemo(() => {
    if (profile && profile.accountId && competitionId && competition) {
      return {
        authorIds: [profile.accountId],
        projectFilter: sorting,
        isContextIgnored: true,
        projectStatus: canAcceptPrivatePublished ? [1, 7, 10] : [1, 7],
        ...(isPromptCompetition ? {} : { exceptCompetitionIds: [competitionId] }),
        onlyAuthors: false,
        ...(!!competitionTags?.length && { tagIds: competitionTags }),
        onlyBooks: ''
      }
    }
  },
    [competitionId, profile, sorting, isPromptCompetition, competitionTags, competition]
  );

  const [projectsPageModel, isProjectsLoading] = useProjectsList(filterOpt, i18n.language, time, !filterOpt)


  const projects = useMemo(() => {
    if (isProjectsLoading) return []
    return projectsPageModel?.data || []
  }, [projectsPageModel, isProjectsLoading])

  const alreadyProjects = useMemo(() => {
    return projects.reduce((acc, p) => {
      if (p?.competitionApproves && (!!p?.competitionApproves?.length || !!p?.pendingCompetitionIds?.length) && competitionId) {
        //@ts-ignore
        if (!!p.competitionApproves?.find?.(({ competitionId }) => competitionId === competition?.competitionId) || p?.pendingCompetitionIds?.includes(competitionId)) // условие необходимо если проекты смогут быть в разных конкурсах
          return [...acc, p?.projectId];
      }
      return acc;
    }, [])
  }, [projects])

  const haveProjects = projects?.length > 0

  //@ts-ignore

  useEffect(() => {
    if (profile && profile.accountId) {
      UserSignAPI.CheckSignsDocuments({
        service: ['competitions'],
        userId: profile.accountId
      })
        .then(d => {
          if (d.status === 200) return d.json(); // список доков
          //if (d.status === 204) setLegalsSigned(false); // у юзера нет неподписанных доков
        })
        .then((d: any) => {
          // //@ts-ignore
          // if (d && competition && competition?.nominations && competition?.nominations[0]?.documentsIds){
          //   //@ts-ignore
          //   const needSign = d.some(x => competition?.nominations[0]?.documentsIds.includes(x));
          //   //setLegalsSigned(needSign);
          //   // d.map((i) => {
          //   //   //@ts-ignore
          //   //   setLegalsSigned(competition?.nominations[0]?.documentsIds.includes(i.documentId))
          //   // })
          // }
        })
    }
  }, [profile, competition]);

  const { userPaidCard } = useUserPaidCard({ competitionId, isPaidApplication: isPaidParticipationContest });

  useEffect(() => {
    if (!resumeLegalContestDeferredApply || !selectedProjectId) {
      return;
    }
    if (!profile) {
      return;
    }
    if (!competition || competition.competitionId !== competitionId) {
      return;
    }
    if (resumeLegalContestApplyOnceRef.current) {
      return;
    }
    resumeLegalContestApplyOnceRef.current = true;

    void onApplyClick({
      forceSelectedProjectId: selectedProjectId,
      makePrivate: shouldSendPrivate,
    });
  }, [
    resumeLegalContestDeferredApply,
    selectedProjectId,
    profile,
    competition,
    competitionId,
    shouldSendPrivate,
    onApplyClick,
  ]);

  const onSendWithoutProjects = useCallback(() => {
    setIsSendWithoutProject(!isSendWithoutProject);
  }, [isSendWithoutProject])

  const maxProjects = useMemo(() => {
    if (isSingleProjectSelection) {
      return 1;
    }
    if (isPaidParticipationContest && !userPaidCard) {
      return 1;
    }
    return (allowedStatus?.allowedMax || 0) - (allowedStatus?.allowedCurrent || 0);
  }, [isSingleProjectSelection, isPaidParticipationContest, userPaidCard, allowedStatus]);

  // Автоматически выбираем проект при возврате от экваиринга
  useEffect(() => {
    if (selectedProjectId && projects.length > 0 && !hasCalledOnApplyClick.current && !hasPreselectedProjectRef.current) {
      const projectExists = projects.some(project => project.projectId === selectedProjectId);

      if (projectExists && !selectedProjects.includes(selectedProjectId)) {
        hasPreselectedProjectRef.current = true;
        setSelectedProjects([selectedProjectId]);
        // Автоматически вызываем onApplyClick если это возврат от экваиринга
        if (onPayApplyClick && !needToFillForm) {
          hasCalledOnApplyClick.current = true; // Устанавливаем флаг
          setTimeout(() => {
            // Вызываем onApplyClick с актуальным selectedProjectId напрямую
            onApplyClick({
              forceSelectedProjectId: selectedProjectId,
              makePrivate: shouldSendPrivate,
            });
          }, 100);
        }
      }
    }
  }, [selectedProjectId, projects, selectedProjects, onPayApplyClick, needToFillForm, onApplyClick, competitionId, shouldSendPrivate, setSelectedProjects])

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
    //setT(Date.now());
  }, []);

  const handleSendWihoutProject = () => {
    const confirm = window.confirm(`Подать заявку на участие без проекта?`)

    if (confirm) {
      try {
        API.request()
          .endpoint(Endpoints.competitions)
          .url('/api/Competition/RequestParticipantToCompetition')
          .post()
          .addQuery('competitionId', competition?.competitionId || '')
          .send()
          .then((r) => {
            if (r?.status === 200) {
              setShowWithoutProjectsModal(true);
            }
          })
      }
      catch (err) {
        console.error('Что-то пошло не так');
      }
    }
  }

  const onMobileSortingClick = useCallback(() => {
    setSorting(sorting === 1 ? 2 : 1);
  }, [sorting, setSorting]);
  const selectedProjectName = useMemo(() => {
    if (selectedProjects.length === 0) return '';
    const selectedProject = projects.find(p => p.projectId === selectedProjects[0]);
    return selectedProject?.title || '';
  }, [selectedProjects, projects]);

  const handleDeselectProject = useCallback(() => {
    setSelectedProjects([]);
  }, []);

  const isAlreadyProject = useCallback((data: string | undefined) => {
    if (alreadyProjects && alreadyProjects.length > 0) {
      return data ? alreadyProjects.includes(data) : false;
    }
  }, [alreadyProjects])

  const noProjectsRequestCheckbox = useMemo(() => (
    <SendProjectCheckbox text={t('teams.modal.without_projects')} checked={isSendWithoutProject} onClick={onSendWithoutProjects} />
  ), [onSendWithoutProjects, t, isSendWithoutProject])

  const disableSend = useMemo(
    () => (canApplyWithoutProject ? (!isSendWithoutProject && selectedProjects?.length === 0) : selectedProjects?.length === 0)
    , [isSendWithoutProject, selectedProjects, canApplyWithoutProject])

  const remainingAttempts = useMemo(() => {
    const maxLimit = getMaxLimitAttemptsPerUser(competition);
    if (maxLimit == null) {
      return undefined;
    }
    const current = allowedStatus?.currentAttemptsPerUser ?? 0;
    return Math.max(maxLimit - current, 0);
  }, [competition, allowedStatus?.currentAttemptsPerUser]);

  const isAttemptsLimitReached = remainingAttempts === 0
    || !!allowedInfo?.includes(CompetitionDisableBtnStatus.max_attempts_per_user)
    || (!!userAttempts
      && userAttempts.competitionId === competitionId
      && userAttempts.max >= 1
      && userAttempts.current >= userAttempts.max);

  const allProjectsSelected = useMemo(() => {
    if (!projects.length || !selectedProjects.length) {
      return false;
    }
    if (remainingAttempts != null) {
      return selectedProjects.length >= Math.min(projects.length, remainingAttempts);
    }
    return projects.length === selectedProjects.length;
  }, [projects, selectedProjects, remainingAttempts]);

  const selectProject = useCallback((projectId: string) => {
    if (isPromptCompetition && isAlreadyProject(projectId)) return;

    setSelectedProjects((prev: string[]) => {
      if (isSingleProjectSelection) {
        return prev.includes(projectId) ? prev.filter(a => a !== projectId) : [projectId];
      }
      if (prev.includes(projectId)) return prev.filter(a => a !== projectId);
      if (remainingAttempts != null && prev.length >= remainingAttempts) {
        toasts.error(t('competition.max_attempts_per_user_reached'));
        return prev;
      }
      return [...prev, projectId];
    });
  }, [isSingleProjectSelection, setSelectedProjects, isPromptCompetition, isAlreadyProject, remainingAttempts, toasts, t]);

  const handleSelectAll = useCallback(() => {
    if (allProjectsSelected) {
      setSelectedProjects([]);
      return;
    }

    if (remainingAttempts != null && projects.length > remainingAttempts) {
      toasts.error(t('competition.max_attempts_per_user_reached'));
      setSelectedProjects(projects.slice(0, remainingAttempts).map((p) => p.projectId));
      return;
    }

    setSelectedProjects(projects.map((p) => p.projectId));
  }, [allProjectsSelected, projects, setSelectedProjects, remainingAttempts, toasts, t]);

  const shouldDisplayTagsString = !!tagString?.length && haveProjects;

  const shouldVisibleNoProjectPromt = useMemo(() => {
    return !haveProjects && !!competition && !isProjectsLoading;
  }, [isProjectsLoading, haveProjects, competition]);

  const isNoProjectsReadyState = shouldVisibleNoProjectPromt;

  const sendProjectsMainTitleText = useMemo(() => {
    if (legalContestProjectThenForm) {
      return t('competition.select_project');
    }
    if (isPaidParticipationContest) {
      return t('competition.pay_title');
    }
    return t('competition.select_project');
  }, [legalContestProjectThenForm, isPaidParticipationContest, t]);

  const handleSubmit = () => {
    if (isSingleProjectSelection && selectedProjects.length > 1) {
      setSelectedProjects(selectedProjects.slice(0, 1));
      return;
    }

    if (legalContestProjectThenForm) {
      const pid = selectedProjects[0];
      if (!pid) {
        toasts.error(t('competition.select_project'));
        return;
      }
      const qs = new URLSearchParams({
        [TEAM_FORM_CONTINUE_COMPETITION_QUERY]: competitionId,
        [TEAM_FORM_DEFER_APPLY_PROJECT_QUERY]: pid,
      }).toString();
      modal.hide();
      history.push(`/teams/form/${PAID_WITH_FORM_LEGAL_ENTITIES_FORM_ID}?${qs}`);
      return;
    }

    if (isSendWithoutProject && selectedProjects?.length === 0) {
      handleSendWihoutProject();
    } else if (isPaidParticipationContest && !userPaidCard) {
      handleSubmitFor({
        projectName: selectedProjectName,
      });
    } else {
      getLegalsModal(needToFillForm, onApplyClick);
    }
  };

  const checkboxComponent = useMemo(() => {
    if (isNoProjectsReadyState) {
      return shouldDisplayNoProjectsCheckbox ? noProjectsRequestCheckbox : null
    }
    if (shouldDisplayNoProjectsCheckbox) {
      return noProjectsRequestCheckbox
    }
    return (
      <>
        {!isSingleProjectSelection && (
          <MagicBoxRow
            onClick={handleSelectAll}
            checked={allProjectsSelected}
            label={t('competition.select_all')}
          />
        )}
        {/* <SendProjectCheckbox
          onClick={handleSelectAll}
          checked={allProjectsSelected}
          text={t('competition.select_all')}
        /> */}
        {competition?.acceptPrivatePublished && (
          <MagicBoxRow
            onClick={() => setShouldSendPrivate(!shouldSendPrivate)}
            checked={shouldSendPrivate}
            label={t('competition.send_private_published')}
          />
        )}
      </>
    )
  }, [isNoProjectsReadyState, shouldDisplayNoProjectsCheckbox, noProjectsRequestCheckbox, isSingleProjectSelection, handleSelectAll, allProjectsSelected, t, competition?.acceptPrivatePublished, setShouldSendPrivate, shouldSendPrivate])

  const tabsComponent = useMemo(() => {
    if (isPromptCompetition) {
      return <SendProjectsTabs tab={tab} onTabChange={setTab} />
    }
    return undefined
  }, [tab, isPromptCompetition]);

  if (!profile) {
    return <NeedLogin competition={competition} />;
  }

  return (
    <ModalContainer style={{ overflow: 'auto', height: '100%' }} justify="flex-start" offsetTop={88} offsetTopMobile={1}>
      <SendProjectModalWrapper directionMobile='column' justify={isMobile ? 'flex-start' : 'center'} align={isMobile ? "center" : 'flex-start'} style={{ position: 'relative' }}>
        <SendProjectsEntity
          isCompetitionModal
          noProjectCheckbox={checkboxComponent}
          titleText={sendProjectsMainTitleText}
          hideMainTitle={isNoProjectsReadyState && !isPaidParticipationContest}
          hideSendButton={isNoProjectsReadyState || isAttemptsLimitReached || isMaxAttemptsLimitLoading}
          subtitleText={shouldDisplayTagsString ? t('competition_edit.create_project_with_tags') + tagString : undefined}
          tabs={tabsComponent}
          noProjectVisible
          hideCount
          hideFilter
          count={0}
          isDisabledSendButton={isAttemptsLimitReached || isMaxAttemptsLimitLoading}
          onMobileSortingClick={onMobileSortingClick}
          onSortingChange={onSortingChange}
          sorting={sorting}
          onSend={() => {
            if (isAttemptsLimitReached) {
              toasts.error(t('competition.max_attempts_per_user_reached'));
              return;
            }
            handleCreateProject('_SELF', { legalContestFormAfterPublish: legalContestProjectThenForm })
          }}
          // isClosed={!(!isSendingCompleted)}
          hide={false}
          sendText={t('competition.create_new_project')}
          showMobileClose
        >
          {filterOpt && (
            <SendProjectsContent
              competition={competition}
              projects={projects}
              selectedProjects={selectedProjects}
              activeTab={tab}
              noProjectsVisible={shouldVisibleNoProjectPromt}
              loading={isProjectsLoading}
              onSelect={selectProject}
              isAlreadyProject={isAlreadyProject}
              legalContestFormAfterPublish={legalContestProjectThenForm}
              isAttemptsLimitReached={isAttemptsLimitReached}
            />
          )}
        </SendProjectsEntity>
        {!showWithoutProjectsModal && (
          <CompetitionSelectPanel
            isEmptyRequest={isSendWithoutProject}
            selectedCount={selectedProjects?.length}
            selectedProjectName={selectedProjectName}
            maxProjects={maxProjects}
            onDeselect={handleDeselectProject}
            onPublish={handleSubmit}
            disabled={disableSend}
          />
        )}
        {showWithoutProjectsModal && <CompleteSend isCompetition title={competition?.name || ''} contextName={''} withoutProjects={true} />}
      </SendProjectModalWrapper>
    </ModalContainer>
  );
};
